import { Head } from "@unhead/react";

import forCoachesBottomSvg from "@/../../hypetrain/static/img/for-coaches-bottom-pattern.svg";
import { SEOHead } from "@/components/helpers/seo/SEOHead";
import { Box, Flex } from "@/components/layout/flexbox";
import { PublicFooter } from "@/components/nav/PublicFooter";
import { PublicNav } from "@/components/nav/PublicNav";
import { ShapesCTA } from "@/components/nav/ShapesCTA";
import { Brands } from "@/components/pieces/marketing/Brands";
import { BuildingCard } from "@/components/pieces/marketing/BuildingCard";
import { CreditSystem } from "@/components/pieces/marketing/CreditSystem";
import { FAQ } from "@/components/pieces/marketing/FAQ";
import { HighSatisfaction } from "@/components/pieces/marketing/HighSatisfaction";
import { SpecialtyTiles } from "@/components/pieces/marketing/SpecialtyTiles";
import { Testimonials } from "@/components/pieces/marketing/Testimonials";
import { UserExperience } from "@/components/pieces/marketing/UserExperience";
import { INNER_BORDER_COLOR, LIGHTEST_BACKGROUND } from "@/css/constants";

import { MainHero } from "./MainHero";

export function PlacementHomePage() {
  return (
    <>
      <SEOHead
        title="Placement – Leadership, Career, and Life Coaching"
        description="Work with a world-class coach to grow as a leader, find career clarity, or accelerate your job search."
        canonicalPath="/"
        image="https://placement-pub.s3.us-east-2.amazonaws.com/home-meta.png"
      />
      <Head>
        <style type="text/css">{`
          #root {
            overflow-x: hidden;
          }
        `}</style>
      </Head>
      <PublicNav />
      <Box backgroundColor={LIGHTEST_BACKGROUND}>
        <MainHero />
        <Brands opacity={1} backgroundColor="transparent" light={true} />
        <BuildingCard
          title="For Businesses & Organizations"
          description="Grow your leaders, retain star performers, and provide a benefit employees will love with Exec, our partner brand."
          ctaLink="https://www.exec.com"
          ctaText="Learn More"
        />
        <HighSatisfaction />
        <SpecialtyTiles />
        <UserExperience />
        <CreditSystem ctaLink="/match" ctaText="Get Started" />
        <Flex justifyContent="center">
          <Box width={325} height={1} backgroundColor={INNER_BORDER_COLOR} />
        </Flex>
        <FAQ />
        <Testimonials />
        <ShapesCTA text="Get started today" background={forCoachesBottomSvg} />
        <PublicFooter />
      </Box>
    </>
  );
}
